import { useCallback } from "react"
import { useCompanyApi } from "../../../../hooks/useCompanyApi"
import { patchAnalysis } from "../../../../lib/api"
import { ActionItemsCardView } from "./ActionItemsCardView"
import type { IProps } from "./interfaces"

/**
 * ActionItemsCard — smart wrapper. Owns the company API client and the
 * owner save handler (patchAnalysis + edit-log refresh); ActionItemsCardView
 * renders the priority-grouped rows from props. Split so the view is
 * Storybookable in isolation, with no `useCompanyApi` in the render path.
 */
export function ActionItemsCard(props: IProps): React.JSX.Element {
  const company = useCompanyApi()
  const { editContext } = props

  const onOwnerSave = useCallback(
    async (fieldPath: string, value: string): Promise<void> => {
      if (!company || !editContext) throw new Error("company unavailable")
      await patchAnalysis(company, editContext.meetingId, fieldPath, value)
      editContext.onEdited()
    },
    [company, editContext],
  )

  return <ActionItemsCardView {...props} onOwnerSave={onOwnerSave} />
}
